import { memoSupports } from './memo.mjs';

const supportsScrollTimeline = /* @__PURE__ */ memoSupports(() => window.ScrollTimeline !== undefined, "scrollTimeline");
const supportsViewTimeline = /* @__PURE__ */ memoSupports(() => window.ViewTimeline !== undefined, "viewTimeline");

export { supportsScrollTimeline, supportsViewTimeline };
//# sourceMappingURL=scroll-timeline.mjs.map
